import { render, staticRenderFns } from "./PracticaInicio.vue?vue&type=template&id=a63ba870&"
import script from "./PracticaInicio.vue?vue&type=script&lang=js&"
export * from "./PracticaInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports